"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICOS_PRIORITY_OVERVIEW_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.PICOS_PRIORITY_OVERVIEW_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment PicOSPriorityOverview on PicOSPriority {\n    id\n    priority\n    name\n    description\n    mandateType\n    displayElements\n    image {\n      id\n      url\n    }\n  }\n"], ["\n  fragment PicOSPriorityOverview on PicOSPriority {\n    id\n    priority\n    name\n    description\n    mandateType\n    displayElements\n    image {\n      id\n      url\n    }\n  }\n"])));
var templateObject_1;
